/**
 * Perfect Paints — pack pricing (1 / 3 / 6 / 12).
 * Qty 1 = Shopify variant.price. Qty 3/6/12 = estimated unit price from multipliers.
 * Bundle intent is submitted via line-item properties when a pack button is clicked.
 */
(function () {
  var PACK_DISCOUNTS = [
    { qty: 1, multiplier: 1 },
    { qty: 3, multiplier: 0.8 },
    { qty: 6, multiplier: 0.75 },
    { qty: 12, multiplier: 0.66 }
  ];

  function discountForQty(qty) {
    var tier = PACK_DISCOUNTS.find(function (t) { return t.qty === qty; });
    return tier ? tier.multiplier : 1;
  }

  /**
   * Shopify product JSON stores money in cents (integer). Guard null/invalid values.
   */
  function parsePriceCents(value) {
    if (value === null || value === undefined || value === '') return 0;
    var n = typeof value === 'string' ? parseFloat(value) : Number(value);
    if (!Number.isFinite(n) || n <= 0) return 0;
    return Math.round(n);
  }

  function packUnitCents(singleUnitCents, qty) {
    if (!singleUnitCents || singleUnitCents <= 0) return 0;
    if (qty <= 1) return singleUnitCents;
    return Math.round(singleUnitCents * discountForQty(qty));
  }

  function packTotalCents(singleUnitCents, qty) {
    var unit = packUnitCents(singleUnitCents, qty);
    if (!unit || qty <= 0) return 0;
    return unit * qty;
  }

  function formatMoney(cents, currency, locale) {
    if (!Number.isFinite(cents) || cents <= 0) return '';
    return new Intl.NumberFormat(locale || undefined, {
      style: 'currency',
      currency: currency
    }).format(cents / 100);
  }

  function savingsPercent(singleUnitCents, packUnitCentsVal) {
    if (singleUnitCents <= 0 || packUnitCentsVal <= 0 || packUnitCentsVal >= singleUnitCents) return 0;
    return Math.round((1 - packUnitCentsVal / singleUnitCents) * 100);
  }

  function initPackPricing(root, product, options) {
    if (!root || !product) return;

    options = options || {};
    var currency = root.dataset.currency || options.currency || 'GBP';
    var qtyInput = options.qtyInput;
    var priceEl = options.priceEl;
    var summaryEl = root.querySelector('[data-pp-pack-summary]');
    var tierBtns = Array.from(root.querySelectorAll('[data-pp-pack-qty]'));
    var atcBtn = options.atcBtn;
    var bundleProps = options.bundleProps || {};
    var selectedQty = 1;
    var lastGoodSingleCents = 0;
    /** Set only when customer clicks a pack tier button (not manual qty edits). */
    var bundleSelection = null;

    function getVariant() {
      if (options.getVariant) {
        return options.getVariant() || product.variants[0];
      }
      return product.variants[0];
    }

    function readSingleUnitCents() {
      var variant = getVariant();
      return parsePriceCents(variant && variant.price);
    }

    function singleUnitCents() {
      var cents = readSingleUnitCents();
      if (cents > 0) lastGoodSingleCents = cents;
      return cents;
    }

    function effectiveSingleCents() {
      var single = singleUnitCents();
      return single > 0 ? single : lastGoodSingleCents;
    }

    function unitCentsForQty(qty) {
      var parsedQty = parseInt(qty, 10) || 1;
      var single = effectiveSingleCents();
      if (single <= 0) return 0;
      if (parsedQty <= 1) return single;
      return packUnitCents(single, parsedQty);
    }

    function totalCentsForQty(qty) {
      var parsedQty = parseInt(qty, 10) || 1;
      var single = effectiveSingleCents();
      if (single <= 0) return 0;
      if (parsedQty <= 1) return single;
      return packTotalCents(single, parsedQty);
    }

    function safeFormatMoney(cents) {
      if (Number.isFinite(cents) && cents > 0) return formatMoney(cents, currency);
      if (lastGoodSingleCents > 0) return formatMoney(lastGoodSingleCents, currency);
      return null;
    }

    function applyBundleProperties() {
      var selectedInput = bundleProps.selected;
      var qtyPropInput = bundleProps.qty;
      var multiplierInput = bundleProps.multiplier;

      if (!selectedInput && !qtyPropInput && !multiplierInput) return;

      if (!bundleSelection) {
        if (selectedInput) {
          selectedInput.value = '';
          selectedInput.disabled = true;
        }
        if (qtyPropInput) {
          qtyPropInput.value = '';
          qtyPropInput.disabled = true;
        }
        if (multiplierInput) {
          multiplierInput.value = '';
          multiplierInput.disabled = true;
        }
        return;
      }

      if (selectedInput) {
        selectedInput.value = 'true';
        selectedInput.disabled = false;
      }
      if (qtyPropInput) {
        qtyPropInput.value = String(bundleSelection.qty);
        qtyPropInput.disabled = false;
      }
      if (multiplierInput) {
        multiplierInput.value = String(bundleSelection.multiplier);
        multiplierInput.disabled = false;
      }
    }

    function clearTierSelection() {
      tierBtns.forEach(function (btn) {
        btn.classList.remove('pp-pack-pricing__tier--active');
        btn.setAttribute('aria-checked', 'false');
      });
    }

    function renderTierPrices() {
      tierBtns.forEach(function (btn) {
        var qty = parseInt(btn.dataset.ppPackQty, 10);
        var unit = unitCentsForQty(qty);
        var priceSpan = btn.querySelector('[data-pp-pack-price]');
        if (!priceSpan) return;
        var formatted = safeFormatMoney(unit);
        if (formatted) priceSpan.textContent = formatted;
      });
    }

    function setActiveTier(qty) {
      selectedQty = qty;
      tierBtns.forEach(function (btn) {
        var isActive = parseInt(btn.dataset.ppPackQty, 10) === qty;
        btn.classList.toggle('pp-pack-pricing__tier--active', isActive);
        btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });
    }

    function syncFromQtyInput() {
      if (!qtyInput) return;
      bundleSelection = null;
      applyBundleProperties();
      clearTierSelection();
      selectedQty = parseInt(qtyInput.value, 10) || 1;
      updateDisplay();
    }

    function updateDisplay() {
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : selectedQty;
      var single = effectiveSingleCents();
      var unit = unitCentsForQty(qty);
      var total = totalCentsForQty(qty);
      var save = savingsPercent(single, unit);

      if (priceEl) {
        var displayCents = qty > 1 ? total : single;
        var formatted = safeFormatMoney(displayCents);
        if (formatted) priceEl.textContent = formatted;
      }

      if (summaryEl) {
        if (qty > 1 && save > 0 && unit > 0) {
          summaryEl.hidden = false;
          summaryEl.textContent =
            qty + ' units · ' + formatMoney(unit, currency) + ' each · Save ' + save + '% vs single unit';
        } else {
          summaryEl.hidden = true;
          summaryEl.textContent = '';
        }
      }

      if (atcBtn && atcBtn.disabled === false) {
        if (qty > 1 && total > 0) {
          atcBtn.textContent = 'Add ' + qty + '-pack to cart — ' + formatMoney(total, currency);
        } else {
          atcBtn.textContent = 'Add to cart';
        }
      }
    }

    function selectPack(qty) {
      if (qtyInput) qtyInput.value = qty;
      setActiveTier(qty);

      if (qty <= 1) {
        bundleSelection = null;
      } else {
        var tier = PACK_DISCOUNTS.find(function (t) { return t.qty === qty; });
        if (tier && tier.multiplier !== 1) {
          bundleSelection = { qty: tier.qty, multiplier: tier.multiplier };
        } else {
          bundleSelection = null;
        }
      }

      applyBundleProperties();
      updateDisplay();
    }

    tierBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectPack(parseInt(btn.dataset.ppPackQty, 10));
      });
    });

    if (qtyInput) {
      qtyInput.addEventListener('change', syncFromQtyInput);
      qtyInput.addEventListener('input', syncFromQtyInput);
    }

    var initialSingle = readSingleUnitCents();
    if (initialSingle > 0) lastGoodSingleCents = initialSingle;

    renderTierPrices();
    selectPack(3);

    return {
      refresh: function () {
        singleUnitCents();
        renderTierPrices();
        applyBundleProperties();
        updateDisplay();
      },
      selectPack: selectPack
    };
  }

  window.PPPackPricing = {
    init: initPackPricing,
    packUnitCents: packUnitCents,
    packTotalCents: packTotalCents,
    PACK_DISCOUNTS: PACK_DISCOUNTS
  };
})();